import {
    FilterableMailBoxUrlSlugs,
    MailBoxUrlSlugs,
    useInfiniteNames,
    useInfiniteTags
} from "@twigsby/client-data";
import {
    ButtonSubmit,
    ColourSolid, ComboBoxControl, DatePickerControl,
    FlexGap,
    FormWrapperLabel,
    Modal, ModalType,
    StackVertical
} from "@twigsby/frontend-framework";
import {Controller, FormProvider, useForm} from "@twigsby/frontend-framework/lib/ReactHookForm";
import {FormatLocaleDate, GetArrayIndexByKeyValue, GetPagedArrayIndexByKeyValue} from "@twigsby/helpers";
import React, {useEffect, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {DeleteFilter, UpdateSingleFilter} from "../../../Helpers/UrlSlugsAndFilters";
import {useMailbox} from "../../../Providers/NewMailboxProvider";
import {useSite} from "../../../Providers/SiteInterfaceProvider";
import {MailScanned, MailType, UnreadType} from "../../../Types/MailFilterDataTypes";
import {NamesComboBox} from "../../Forms/NamesComboBox";
import AddTagControlMinimal from "../../Tags/AddTagControlMinimal";

interface MailboxFilterModalType extends ModalType {

}

const FilterMailboxModal = (props: MailboxFilterModalType) => {
    const { t } = useTranslation();
    const { currentLocale } = useSite();

    const {
        userFilters,
        SetFilters
    } = useMailbox();

    const [ localFilters , setLocalFilters ] = useState<FilterableMailBoxUrlSlugs>(userFilters);

    const formMethods = useForm();

    const { data: tagData } = useInfiniteTags();
    const { data: namesData} = useInfiniteNames();

    const {
        control,
    } = formMethods;

    const HandleSubmit = () => {
        SetFilters(localFilters as MailBoxUrlSlugs);
        props.closeCallback();
    }

    useEffect(() => {
        console.log('userFilters', userFilters);
        if(props.isOpen) {
            setLocalFilters(userFilters);
        }
    }, [userFilters, props.isOpen]);

    return (
        <Modal title={t('mailboxes.filter.title')} isOpen={props.isOpen} closeCallback={props.closeCallback}>
            <FormProvider {...formMethods}>
                <form onSubmit={formMethods.handleSubmit(HandleSubmit)}>
                    <fieldset>

                        <StackVertical gap={FlexGap.Medium}>

                            <div className={'row'}>
                                <div className={'col-xs-12 col-md-6'}>

                                    <StackVertical gap={FlexGap.Medium}>

                                        <Controller
                                            name={'mailType'}
                                            control={control}
                                            render={({ field, fieldState}) =>
                                                <FormWrapperLabel
                                                    label={t('mailboxes.filter.labels.mailType')}
                                                    invalid={fieldState.invalid}
                                                    validationMessage={fieldState.error?.message}
                                                >
                                                    <ComboBoxControl
                                                        name={'mailType'}
                                                        placeholder={t('mailboxes.filter.controls.mailTypePlaceholder')}
                                                        data={MailType}
                                                        valueType={'number'}
                                                        singleSelection={true}
                                                        defaultValues={localFilters && localFilters['mailType'] ? [localFilters['mailType'].value] : undefined}
                                                        forwardValueCallback={(e) => {
                                                            field.onChange(e);
                                                            setLocalFilters((prevState) => UpdateSingleFilter(prevState, 'mailType', e, MailType[GetArrayIndexByKeyValue(MailType, 'value', e)].label) as MailBoxUrlSlugs);
                                                        }}
                                                    />
                                                </FormWrapperLabel>
                                            }
                                        />

                                        <Controller
                                            name={'term'}
                                            control={control}
                                            render={({ field, fieldState}) =>
                                                <FormWrapperLabel
                                                    label={t('mailboxes.filter.labels.textSearch')}
                                                    invalid={fieldState.invalid}
                                                    validationMessage={fieldState.error?.message}
                                                >
                                                    <input
                                                        type='text'
                                                        onChange={(e:any) => {
                                                            field.onChange(e.currentTarget.value);
                                                            setLocalFilters((prevState) => UpdateSingleFilter(prevState, 'term', e.currentTarget?.value, t('messageCentre.filter.labels.searchTerm', { value: e.currentTarget?.value})) as MailBoxUrlSlugs);
                                                        }}
                                                        defaultValue={localFilters && localFilters['term'] ? localFilters['term'].value as string : undefined}

                                                    />
                                                </FormWrapperLabel>
                                            }
                                        />

                                        <NamesComboBox
                                            name={'incomingRecipientNameIds'}
                                            control={control}
                                            defaultValues={localFilters && localFilters['incomingRecipientNameIds'] && props.isOpen ? localFilters['incomingRecipientNameIds']?.value as Array<number> : undefined}
                                            resetSelectedCallback={() => setLocalFilters((prevState) => DeleteFilter(prevState, 'incomingRecipientNameIds') as MailBoxUrlSlugs)}
                                            onChangeCallback={(e) => {
                                                let label = t('mailboxes.filter.counts.names', { count: e.length });

                                                if(e.length === 1 && namesData) {
                                                    const indexes = GetPagedArrayIndexByKeyValue(namesData as any, 'id', e[0]);
                                                    label = indexes ? `${t('labels.name')}: ${namesData?.pages[indexes?.pageIndex].data[indexes?.itemIndex].name}` : label;
                                                }
                                                setLocalFilters((prevState) => UpdateSingleFilter(prevState, 'incomingRecipientNameIds', e, label) as MailBoxUrlSlugs);
                                            }}
                                        />

                                        <Controller
                                            name={'unreadStatus'}
                                            control={control}
                                            render={({ field, fieldState}) =>
                                                <FormWrapperLabel
                                                    label={t('mailboxes.filter.labels.unreadStatus')}
                                                    invalid={fieldState.invalid}
                                                    validationMessage={fieldState.error?.message}
                                                >
                                                    <ComboBoxControl
                                                        name={'unreadStatus'}
                                                        placeholder={t('mailboxes.filter.controls.unreadStatusPlaceholder')}
                                                        data={UnreadType}
                                                        valueType={'number'}
                                                        singleSelection={true}
                                                        defaultValues={localFilters && localFilters['unreadStatus'] ? [localFilters['unreadStatus'].value] : undefined}
                                                        forwardValueCallback={(e) => {
                                                            field.onChange(e);
                                                            setLocalFilters((prevState) => UpdateSingleFilter(prevState, 'unreadStatus', e, UnreadType[GetArrayIndexByKeyValue(UnreadType, 'value', e)].label) as MailBoxUrlSlugs);
                                                        }}
                                                    />
                                                </FormWrapperLabel>
                                            }
                                        />
                                    </StackVertical>
                                </div>
                                <div className={'col-xs-12 col-md-6'}>
                                    <StackVertical gap={FlexGap.Medium}>
                                        <Controller
                                             name={'scanned'}
                                             control={control}
                                             render={({ field, fieldState}) =>
                                                 <FormWrapperLabel
                                                     label={t('mailboxes.filter.labels.mailScanned')}
                                                     invalid={fieldState.invalid}
                                                     validationMessage={fieldState.error?.message}
                                                 >
                                                     <ComboBoxControl
                                                         name={'scanned'}
                                                         placeholder={t('mailboxes.filter.controls.mailScannedPlaceholder')}
                                                         data={MailScanned}
                                                         valueType={'number'}
                                                         singleSelection={true}
                                                         defaultValues={localFilters && localFilters['scanned'] ? [localFilters['scanned'].value] : undefined}
                                                         forwardValueCallback={(e) => {
                                                             field.onChange(e);
                                                             setLocalFilters((prevState) => UpdateSingleFilter(prevState, 'scanned', e, MailScanned[GetArrayIndexByKeyValue(MailScanned, 'value', e)].label) as MailBoxUrlSlugs);
                                                         }}
                                                     />
                                                 </FormWrapperLabel>
                                            }
                                        />

                                        <Controller
                                            name={'mailTagIds'}
                                            control={control}
                                            render={({ field, fieldState}) =>
                                                <FormWrapperLabel
                                                    label={t('mailboxes.filter.labels.tags')}
                                                    invalid={fieldState.invalid}
                                                    validationMessage={fieldState.error?.message}
                                                >
                                                    <AddTagControlMinimal
                                                        name={'mailTagIds'}
                                                        existingTags={localFilters && localFilters['mailTagIds']&& props.isOpen ? localFilters['mailTagIds']?.value as Array<number> : undefined}
                                                        updateCallback={(e: Array<any>) => {
                                                            field.onChange(e);

                                                            let label = t('mailboxes.filter.counts.tags', {count: e.length});

                                                            if(e.length === 1 && tagData) {
                                                                const indexes = GetPagedArrayIndexByKeyValue(tagData as any, 'id', e[0]);
                                                                label = indexes ? `${t('labels.tag')}: ${tagData?.pages[indexes?.pageIndex].data[indexes?.itemIndex].name}` : label;
                                                            }

                                                            setLocalFilters((prevState) => UpdateSingleFilter(prevState, 'mailTagIds', e, label) as MailBoxUrlSlugs);
                                                        }}
                                                        resetSelectedCallback={() => setLocalFilters((prevState) => DeleteFilter(prevState, 'mailTagIds') as MailBoxUrlSlugs)}
                                                    />
                                                </FormWrapperLabel>
                                            }
                                        />

                                        <Controller
                                            name={'dateRange'}
                                            control={control}
                                            render={({ field, fieldState}) =>
                                                <FormWrapperLabel
                                                    label={t('mailboxes.filter.labels.dateRange')}
                                                    invalid={fieldState.invalid}
                                                    validationMessage={fieldState.error?.message}
                                                >
                                                    <DatePickerControl
                                                        name="dateRange"
                                                        maxDate={new Date()}
                                                        forwardValuesCallback={(e) => {
                                                            formMethods.setValue('startDate', e.startDate);
                                                            formMethods.setValue('endDate', e.endDate);
                                                            setLocalFilters((prevState) => UpdateSingleFilter(prevState, 'startDate', e.startDate, t('messageCentre.filter.labels.startDate', { date: FormatLocaleDate(e.startDate, currentLocale) })) as MailBoxUrlSlugs);
                                                            setLocalFilters((prevState) => UpdateSingleFilter(prevState, 'endDate', e.endDate, t('messageCentre.filter.labels.endDate', { date: FormatLocaleDate(e.endDate, currentLocale) })) as MailBoxUrlSlugs);
                                                        }}
                                                        defaultStartDate={localFilters && localFilters['startDate']?.value ? localFilters['startDate'].value as Date : undefined}
                                                        defaultEndDate={localFilters && localFilters['endDate']?.value ? localFilters['endDate'].value as Date : undefined}
                                                        locale={currentLocale}
                                                        moveRangeOnFirstSelection={false}
                                                    />
                                                </FormWrapperLabel>
                                            }
                                        />

                                    </StackVertical>
                                </div>
                            </div>

                            <ButtonSubmit
                                fullWidth={true}
                                colour={ColourSolid.Primary}
                                title={t('mailboxes.filter.actions.save')}
                            />
                        </StackVertical>

                    </fieldset>
                </form>
            </FormProvider>
        </Modal>
    )
}

export default FilterMailboxModal
